import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeAnalyze: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeAnalyze"><Path fillRule="evenodd" clipRule="evenodd" d="M13 4V5L16.5 6.5L18 10H19L20.5 6.5L21 6.28516V21H3V3H15.333L13 4ZM7 16.9004H14V15.0996H7V16.9004ZM7 12.9004H10.5V11.0996H7V12.9004ZM12 12.9004H17V11.0996H12V12.9004ZM7 8.90039H13V7.09961H7V8.90039Z" fill="currentColor"/><Path d="M18.5 1L19.4453 3.55468L22 4.5L19.4453 5.44532L18.5 8L17.5547 5.44532L15 4.5L17.5547 3.55468L18.5 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeAnalyze;
